import { createI18n } from "vue-i18n";
import ko from "./ko.json";
import zh from "./zh.json";

const messages = {
  "ko-KR": ko,
  "zh-CN": zh,
};

// 默认韩语
const locale = localStorage.getItem("language") || "ko-KR";

const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: "ko-KR",
  messages,
});

export default i18n;